import React from "react";

const brandImages = require.context('../../images/brands', false);
const imagePaths = brandImages.keys();

function Brands() {
    const midpoint = Math.ceil(imagePaths.length / 2);
    const rows = [
        imagePaths.slice(0, midpoint),
        imagePaths.slice(midpoint)
    ];

    return (
        <div className="brands-carousel">
            {rows.map((row, i) => (
                <div className={`carousel-row${i === 1 ? " reverse" : ""}`} key={i}>
                    {[...row, ...row].map((imagePath, idx) => {
                        const fileName = imagePath
                            .replace(/^.*[\\/]/, '')
                            .replace(/\.[^/.]+$/, '')
                            .replace(/-/g, ' ');
                        return (
                            <div className="brand-logo" key={idx + imagePath}>
                                <img src={brandImages(imagePath)} alt={fileName} />
                                <span>{fileName}</span>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}

export default Brands;